import * as t from 'io-ts';
import {
  CHARGEBEE_ENABLED,
  INTEGRATIONS_ENABLED,
  SSO_ENABLED,
  ANALYTICS_ENABLED,
  ONBOARDING_ENABLED,
  AI_TEMPLATE_ENABLED,
  ENTITIES_UPLOAD_ENABLED,
  ENTITY_TYPE_OF_RESPONSE_ENABLED,
  SESSION_LIMITATION_ENABLED,
  AVERAGE_WEIGHTED_SCORE_CALCULATION_ENABLED,
  DISABLE_FREE_PLAN_ENABLED,
  APPROVALS_ENABLED,
  DISCOUNT_FOR_CHURNS_ENABLED,
  REPORT_VIEW_RESTRICTIONS_ENABLED,
  AI_PRICING_ENABLED,
  AI_CHAT_ENABLED,
  LAST_LOGIN_ENABLED,
  ENTITY_PROPERTIES_ENABLED,
  ENTITY_PROPERTY_PREFILL_ENABLED,
  WORD_TEMPLATE_REPORT_ENABLED,
  AI_BLUR_FACES_ENABLED,
  AI_IMAGE_VALIDATION_ENABLED,
  AI_IMPROVE_WRITING_ENABLED,
} from '@/entities/features/constants';
import { withFallback } from 'io-ts-types/lib/withFallback';

export const featuresCodec = t.type({
  sso_enabled: t.boolean,
  integrations_enabled: t.boolean,
  chargebee_enabled: t.boolean,
  analytics_enabled: t.boolean,
  onboarding_enabled: t.boolean,
  ai_template_enabled: t.boolean,
  entities_upload_enabled: t.boolean,
  entity_type_of_response_enabled: withFallback(t.boolean, false),
  session_limitation_enabled: withFallback(t.boolean, false),
  average_weighted_score_calculation_enabled: withFallback(t.boolean, false),
  tbr_enabled: withFallback(t.boolean, false),
  file_type_of_response_enabled: withFallback(t.boolean, false),
  disable_free_plan_enabled: withFallback(t.boolean, false),
  approvals_enabled: withFallback(t.boolean, false),
  discount_for_churns_enabled: withFallback(t.boolean, false),
  report_view_restrictions_enabled: withFallback(t.boolean, false),
  rocc_scoring_enabled: withFallback(t.boolean, false),
  form_translations_enabled: withFallback(t.boolean, false),
  manual_form_translations_enabled: withFallback(t.boolean, false),
  rte_enabled: withFallback(t.boolean, false),
  ai_pricing_enabled: withFallback(t.boolean, false),
  ai_chat_enabled: withFallback(t.boolean, false),
  entity_properties_enabled: withFallback(t.boolean, false),
  entity_property_prefill_enabled: withFallback(t.boolean, false),
  ai_image_description_enabled: withFallback(t.boolean, false),
  ai_pack_enabled: withFallback(t.boolean, false),
  last_login_enabled: withFallback(t.boolean, false),
  word_template_report_enabled: withFallback(t.boolean, false),
  ai_blur_faces_enabled: withFallback(t.boolean, false),
  ai_image_validation_enabled: withFallback(t.boolean, false),
  ai_improve_writing_enabled: withFallback(t.boolean, false),
});

export const featuresResponseCodec = t.type({
  data: featuresCodec,
});

export const AllowedFeatures = [
  SSO_ENABLED,
  INTEGRATIONS_ENABLED,
  CHARGEBEE_ENABLED,
  ANALYTICS_ENABLED,
  ONBOARDING_ENABLED,
  AI_TEMPLATE_ENABLED,
  ENTITIES_UPLOAD_ENABLED,
  ENTITY_TYPE_OF_RESPONSE_ENABLED,
  SESSION_LIMITATION_ENABLED,
  AVERAGE_WEIGHTED_SCORE_CALCULATION_ENABLED,
  DISABLE_FREE_PLAN_ENABLED,
  APPROVALS_ENABLED,
  DISCOUNT_FOR_CHURNS_ENABLED,
  REPORT_VIEW_RESTRICTIONS_ENABLED,
  AI_PRICING_ENABLED,
  AI_CHAT_ENABLED,
  ENTITY_PROPERTIES_ENABLED,
  ENTITY_PROPERTY_PREFILL_ENABLED,
  LAST_LOGIN_ENABLED,
  WORD_TEMPLATE_REPORT_ENABLED,
  AI_BLUR_FACES_ENABLED,
  AI_IMAGE_VALIDATION_ENABLED,
  AI_IMPROVE_WRITING_ENABLED,
];

export type AllowedFeaturesType = keyof typeof featuresCodec.props;
export type AllowedFeaturesResponseType = {
  data: AllowedFeaturesType;
};
